import { Component, DestroyRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Api } from '../../../smoothr-web-app-core/api/api';
import { Gender } from 'src/smoothr-web-app-core/enums/Gender';
import { TranslateService } from '@ngx-translate/core';

import Venue from 'src/smoothr-web-app-core/models/Venue';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NavigationService } from 'src/app/services/navigation.service';
import { IonInput, ModalController } from '@ionic/angular';
import { countries } from 'src/app/components/input-phone-with-county-code/mock-countries';
import { Location } from '@angular/common';
import Customer from 'src/smoothr-web-app-core/models/Customer';
import { InfoModalComponent } from 'src/app/components/info-modal/info-modal.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

@Component({
	selector: 'app-user-data',
	templateUrl: './user-data.page.html',
	styleUrls: ['user-data.page.scss'],
})
export class UserDataPage implements OnDestroy, OnInit {
	static url = 'user-data';
	showRePassword = false;
	showPassword = false;
	passwordsMatching = false;
	isValidEmail = true;
	isValidName = true;
	isValidPassword = true;
	isValidRePassword = true;
	venue: Venue;
	email = 'email';
	password = 'password';
	rePassword = 'rePassword';
	fullName = 'fullName';
	gender = 'gender';
	agbChecked = 'agbChecked';
	day = 'day';
	month = 'month';
	year = 'year';
	phone = 'phone';

	loading = false;

	userDataForm: FormGroup | null = null;

	code = '';
	display: string = '';
	showTimerButton = true;

	public isEditableVenueSelection = true;

	constructor(
		private translate: TranslateService,
		private router: Router,
		private repository: RepositoryService,
		private snackbarCtrl: MatSnackBar,
		private fb: FormBuilder,
		private navigationService: NavigationService,
		private location: Location,
		private modalCtrl: ModalController,
		private destroyRef: DestroyRef
	) {
		(window as any).repository = this.repository;
		if (repository.customer && !repository.customer.isAnonymous) {
			this.navigationService.account();
			return;
		}
		repository.customerAuth.pipe(takeUntilDestroyed(destroyRef)).subscribe(customerAuth => {
			console.log('CustomerAuth received', customerAuth);
			this.userDataForm = this.createUserDataForm(customerAuth?.customer);
		});
	}
	ngOnInit() {
		this.userDataForm = this.createUserDataForm(this.repository.customer);
	}

	createUserDataForm(customer: Customer | null): FormGroup {
		console.log('createUserDataForm()');
		let defaultPhone = {
			country: '+49',
			phone: '',
		};

		if (customer?.phone) {
			let countryCode = countries.find(it => customer?.phone?.trim().startsWith('+' + it.dialCode));
			defaultPhone = {
				country: '+' + countryCode?.dialCode ?? '+49',
				phone: customer?.phone ? customer?.phone?.trim()?.replace('+' + countryCode?.dialCode, '') : '',
			};
		}

		let birthDate: Date | null;
		if (customer?.birthDate) {
			birthDate = new Date(customer.birthDate);
		} else {
			birthDate = null;
		}
		let month: number | null;
		if (birthDate) {
			month = birthDate.getMonth() + 1;
		} else {
			month = null;
		}
		return new FormGroup({
			gender: new FormControl(customer?.gender ?? '', [Validators.required, Validators.pattern(/\w+/)]),
			fullName: new FormControl(customer?.name ?? '', [Validators.required, Validators.pattern(/\w+\s\w+/)]),
			email: new FormControl(customer?.email ?? '', [Validators.required, Validators.email]),
			day: new FormControl(birthDate?.getDate() ?? '', [Validators.max(31)]),
			month: new FormControl(month ?? '', [Validators.max(12)]),
			year: new FormControl(birthDate?.getFullYear() ?? '', [Validators.min(1900)]),
			phone: new FormControl(defaultPhone, [this._customPhoneValidatorForLibrary]),
		});
	}

	private _customPhoneValidatorForLibrary(control: AbstractControl) {
		if (!control.value?.phone) {
			return null;
		}
		try {
			const phoneNumber = parsePhoneNumberFromString(control?.value?.country + control?.value?.phone.toString());
			if (phoneNumber.isValid() && phoneNumber.isPossible()) {
				return null;
			} else {
				return { invalidPhone: true };
			}
		} catch (e) {
			return { invalidCountryCode: true };
		}
	}

	isValid(controlName?: string): boolean {
		try {
			if (controlName) {
				return this.userDataForm.get(controlName)?.hasError('required') && this.userDataForm.get(controlName)?.touched;
			}
			return this.userDataForm.valid;
		} catch (e) {
			console.log(`Error while getting userDataForm data for ${controlName}: ${e.message}`);
			return false;
		}
	}

	isValidByPattern(controlName?: string): boolean {
		try {
			if (controlName) {
				return this.userDataForm.get(controlName)?.errors && !this.userDataForm.get(controlName)?.hasError('required');
			}
			return this.userDataForm.invalid;
		} catch (e) {
			console.log(`Error while getting userDataForm data for ${controlName}: ${e.message}`);
			return false;
		}
	}

	getControlValue(controlName?: string) {
		if (controlName) {
			return this.userDataForm?.get(controlName)?.value;
		}
		return '';
	}

	ngOnDestroy() {
		console.log('ngOnDestroy()');
	}
	async update() {
		try {
			this.loading = true;

			const response = await Api.patchCustomer({
				...this.repository.customer,
				name: this.getControlValue('fullName'),

				// email: this.getControlValue('email'),
				preferredVenues: [],
				phone:
					this.getControlValue('phone')?.phone && this.getControlValue('phone')?.country
						? this.getControlValue('phone')?.country + this.getControlValue('phone')?.phone
						: null,
				birthDate:
					this.getControlValue(this.year) && this.getControlValue(this.month) && this.getControlValue(this.day)
						? new Date(
								new Date(0).setFullYear(
									this.getControlValue(this.year),
									Number(this.getControlValue(this.month)) - 1,
									this.getControlValue(this.day)
								)
							).toString()
						: '',
			});

			const mainUser = this.repository._customerAuth;
			mainUser.customer = { ...mainUser.customer, ...response.data };
			this.repository.customerAuth.next(mainUser);
			this.loading = false;
			this.snackbarCtrl.open('Your account was updated', '', {
				duration: 4000,
			});
			// await InformationModalComponent.show(this.modalCtrl, {
			// 	title: this.translate.instant('sign_up.success'),
			// 	info: this.translate.instant('sign_up.updated'),
			// 	closeButton: this.translate.instant('add_points.close')
			// });
		} catch (e) {
			console.log(e);
			this.loading = false;

			if (e?.response?.data?.message) {
				this.snackbarCtrl.open(e.response.data.message, '', {
					duration: 4000,
				});
			} else {
				this.snackbarCtrl.open(this.translate.instant('account.error'), '', {
					duration: 2000,
				});
			}
		}
	}
	timer(minute: number) {
		let seconds: number = minute * 60;
		let textSec: any = '0';
		let statSec: number = 60;

		const prefix = minute < 60 ? '0' : '';

		const timer = setInterval(() => {
			this.showTimerButton = true;
			seconds--;
			if (statSec != 0) statSec--;
			else statSec = 59;

			if (statSec < 10) {
				textSec = '0' + statSec;
			} else textSec = statSec;

			this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

			if (seconds == 0) {
				clearInterval(timer);
				this.display = '';
				this.showTimerButton = false;
			}
		}, 1000);
	}

	goBack() {
		if (this.repository._order === null) {
			this.navigationService.home();
		} else {
			this.navigationService.menu();
		}
	}
	gotoNextField(nextElement: IonInput) {
		nextElement.setFocus();
	}
	getErrorsForm(controlName) {
		try {
			if (controlName) {
				return this.userDataForm.get('phone')?.errors;
			}
		} catch (e) {
			console.log(`Error while getting userDataForm ERORS data for ${controlName}: ${e.message}`);
		}
		return null;
	}

	async deleteAccount() {
		const result = await InfoModalComponent.show(this.modalCtrl, {
			title: this.translate.instant('account.delete_account.header'),
			info: this.translate.instant('account.delete_account.msg'),
			mainButton: this.translate.instant('account.delete_account.yes'),
			closeButton: this.translate.instant('account.delete_account.no'),
		});
		if (result && this.repository?._customerAuth && this.repository?._customerAuth?.customer) {
			try {
				await Api.deleteAccount();
				this.snackbarCtrl.open(this.translate.instant('account.delete_account.success'), null, {
					duration: 3000,
				});
				this.repository.customerAuth.next(null);
				await this.navigationService.home();
			} catch (e) {
				this.loading = false;
				this.snackbarCtrl.open(this.translate.instant('account.delete_account.error'), null, {
					duration: 3000,
				});
			}
		}
		console.log(result);
	}
}
